import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { getPx } from '../../helpers/common';
import { isDefined } from '../../helpers/defined';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../../helpers/media-style';
export var alignStyle = css(_templateObject(), function (_ref) {
  var $lineHeight = _ref.$lineHeight,
      $multiline = _ref.$multiline,
      _ref$$vertical = _ref.$vertical,
      $vertical = _ref$$vertical === void 0 ? false : _ref$$vertical;
  return $multiline && isDefined($lineHeight) ? styleArrayForBreakpoints([$lineHeight, $vertical], function (_ref2) {
    var $height = _ref2[0],
        $vertical = _ref2[1];
    return !$vertical && $multiline ? "height: " + getPx($height) + ";" : '';
  }) : '';
}, function (_ref3) {
  var $multiline = _ref3.$multiline,
      _ref3$$vertical = _ref3.$vertical,
      $vertical = _ref3$$vertical === void 0 ? false : _ref3$$vertical;
  return $multiline ? styleForBreakpoints($vertical, function ($vertical) {
    return !$vertical && $multiline ? "align-self: flex-start;" : '';
  }) : '';
});